import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import CSS from 'csstype';
import React, { useContext } from 'react';

import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';

import getLanguageObject from 'utils/getLanguageObject';

const antIcon = (
    <LoadingOutlined
        style={{
            fontSize: 24
        }}
        spin={true}
    />
);

type LoadingWrapperProps = {
    children: React.ReactNode;
    loading: boolean;
    error?: string;
    style?: CSS.Properties;
    loadingText?: string;
};

const LoadingWrapper: React.FC<LoadingWrapperProps> = ({
    children,
    loading,
    error,
    style,
    loadingText = 'NACITANI'
}: LoadingWrapperProps) => {
    const { language } = useContext(Context);
    if (error)
        return (
            <p>
                <TranslateText>CHYBA_NACITANI</TranslateText>: {error}
            </p>
        );
    return (
        <Spin
            indicator={antIcon}
            spinning={loading}
            tip={getLanguageObject(language)[loadingText] || loadingText}
            size="large"
            style={style}
        >
            {children}
        </Spin>
    );
};

export default LoadingWrapper;
